module.exports = __webpack_public_path__ + "img/green.0222de17.png";